import IMenuEntry from "common/interfaces/IMenuEntry";
import {appUrlsService} from "common/services";

export default [
	{
		title: "Dashboards",
		id: "dashboards",
		iconName: "icon-dashboard-2",
		link: {to: appUrlsService.dashboards()},
		items: [
			{
				title: "Dashboards List",
				link: {to: appUrlsService.dashboards()},
			},
			{
				title: "Create Dashboard",
				link: {to: appUrlsService.createDashboard()},
				scope: "create:dashboard"
			}
		]
	},
	{
		title: "Charts",
		iconName: "icon-dashboard",
		link: {to: appUrlsService.charts()},
		items: [
			{
				title: "Charts List",
				link: {to: appUrlsService.charts()}
			},
			{
				title: "Create Chart",
				link: {to: appUrlsService.createChart()},
				scope: "create:chart"
			}
		]
	},
	{
		title: "Reporting",
		iconName: "icon-reporting",
		link: {to: appUrlsService.reporting()},
	},
	{
		title: "Schedule Reporting",
		iconName: "icon-reporting",
		link: {to: appUrlsService.scheduleReports()},
		scope: "manage:schedule_reports"
	},
	{
		title: "Change Logs",
		iconName: "icon-history",
		link: {to: appUrlsService.changeLogs()}
	},
] as IMenuEntry[];
